module.exports = __webpack_public_path__ + "img/05.755eb969.png";